module.exports = __webpack_public_path__ + "zmenseni-prsou_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_8_after.jpg
// module id = 1291
// module chunks = 0